<mat-card>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
        <form #f="ngForm" [formGroup]="configForm" (ngSubmit)="actionForm()" class="pb-3 config-hdld">
            <mat-accordion>
                <mat-expansion-panel expanded="true" [hideToggle]="false" class="mt-3">
                    <mat-expansion-panel-header (click)="$event.stopPropagation()">
                        <mat-panel-title class="mat-panel-title" style="width: 70%">
                            {{ "labor_utilization_report.general_configuration" | translate }}
                            <span class="edit-icon-btn" (click)="onClickBtnViewUpdate()">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.99999 14C7.99999 13.515 7.9452 13.2282 7.99999 13C8.04856 12.7977 7.89127 13.1774 7.99999 13C8.12261 12.7999 8.65706 12.3429 8.99999 12L18 3.00001C18.8213 2.17871 20.1787 2.17871 21 3.00001C21.8213 3.82132 21.8213 5.1787 21 6.00001L12 15C11.6571 15.3429 11.2001 15.8774 11 16C10.8226 16.1087 11.2023 15.9514 11 16C10.7718 16.0548 10.485 16 9.99999 16H7.99999V14Z" stroke="#ff000d" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M13 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V10" stroke="#ff000d" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>                                    
                              </span>
                        </mat-panel-title>
                        <span class="sync-info">
                            <mat-icon class="sync-info-icon">info</mat-icon>
                            {{ "labor_utilization_report.sync_data_from_enterprise" | translate }}
                          </span>
                    </mat-expansion-panel-header>
                <div class="row">
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.tax_code" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.taxCode || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.taxCode || ''"
                            disabled
                          />   
                          </span>                     
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.enterprise_name" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.name || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.name || ''"
                            disabled
                          />   
                          </span>                     
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.address" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.addresses[0].address ? enterprises.addresses[0].address : ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.addresses[0].address ? enterprises.addresses[0].address : ''"
                            disabled
                          />      
                          </span>                  
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.fax" | translate }}
                          </label>
                          <span
                            matTooltip="{{ enterprises.fax || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.fax || ''"
                            disabled
                          />    
                          </span>                    
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.representative" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.representative || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.representative || ''"
                            disabled
                          />  
                          </span>                      
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.position" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.position || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.position || ''"
                            disabled
                          /> 
                          </span>                       
                    </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.birthday" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.birthdayDisplay || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.birthdayDisplay || ''"
                            disabled
                          /> 
                          </span>                       
                    </div>
                    <div class="col-3 mt-3">
                      <label class="form-label">
                          {{ "labor_utilization_report.phone" | translate }} <span class="required">*</span>
                        </label>
                        <span
                          matTooltip="{{ enterprises.phone || ''}}"
                          style="display:block;"
                          >
                        <input
                          nz-input
                          class="underline-input"
                          [value]="enterprises.phone || ''"
                          disabled
                        /> 
                        </span>                       
                  </div>
                    <div class="col-3 mt-3">
                        <label class="form-label" style="display: block;">
                          {{ "labor_utilization_report.gender" | translate }} <span class="required">*</span>
                        </label>
                        <nz-radio-group [ngModel]="enterprises.sex" [ngModelOptions]="{standalone: true}" [nzDisabled]="true">
                          <label nz-radio [nzValue]="true">{{ "labor_utilization_report.male" | translate }}</label>
                          <label nz-radio [nzValue]="false">{{ "labor_utilization_report.female" | translate }}</label>
                        </nz-radio-group>
                      </div>
                    <div class="col-3 mt-3">
                        <label class="form-label">
                            {{ "labor_utilization_report.email" | translate }} <span class="required">*</span>
                          </label>
                          <span
                            matTooltip="{{ enterprises.email || ''}}"
                            style="display:block;"
                            >
                          <input
                            nz-input
                            class="underline-input"
                            [value]="enterprises.email || ''"
                            disabled
                          />   
                          </span>                     
                    </div>
                </div>
                </mat-expansion-panel>
            </mat-accordion>

            <mat-accordion [multi]="true">
                <mat-expansion-panel expanded="true" class="mt-3">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                        {{ "labor_utilization_report.additional_business_info_in_report" | translate }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                    <div class="row">                   
                        <div class="col-3">
                            <mat-form-field class="w-100">
                              <mat-label>{{ "labor_utilization_report.national" | translate }} <span class="required">*</span></mat-label>
                              <mat-select
                                id="national"
                                name="national"
                                formControlName="national"
                                [placeholder]="'labor_utilization_report.select_nationality' | translate"
                                required>
                                <mat-option
                                  *ngFor="let item of listNational"
                                  [value]="item.ma"
                                  [matTooltip]="item.ten">
                                  {{ item.ten }}
                                </mat-option>
                              </mat-select>
                              <button *ngIf="configForm.controls['national'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('national')">
                                <mat-icon>close</mat-icon>
                              </button>
                              <mat-error *ngIf="!configForm.controls['national'].value">
                                {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.national" | translate)}) }}
                              </mat-error>
                            </mat-form-field>
                          </div>
                        <!-- <div class="col-3"> -->
                            <!-- Lĩnh vực hoạt động -->
                            <!-- <mat-form-field class="w-100">
                              <mat-label>{{'labor_utilization_report.business_field' | translate}}</mat-label>
                              <mat-select id="status" name="status" formControlName="businessField"
                                    [placeholder]="'labor_utilization_report.select_business_industry' | translate" required>
                                    <mat-option>
                                        <ngx-mat-select-search
                                            [formControl]="searchBusinessFieldCtrl"
                                            [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                        >
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let businessFieldData of listBusinessFieldFilter | async" [value]="businessFieldData?.ma" [matTooltip]="businessFieldData?.ten">
                                        {{ businessFieldData?.ten }}
                                    </mat-option>
                                </mat-select>
                                <button *ngIf="configForm.controls['businessField'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('businessField')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="!configForm.controls['businessField'].value">
                                    {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.business_field" | translate)}) }}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <!-- <div class="col-3">  -->
                            <!-- Ngành nghề kinh doanh -->
                            <!-- <mat-form-field class="w-100">
                                <mat-label>{{'labor_utilization_report.business_industry' | translate}}</mat-label>
                                <mat-select id="status" name="status" formControlName="profession"
                                    [placeholder]="'labor_utilization_report.enter_enterprise_type' | translate" required>
                                    <mat-option>
                                        <ngx-mat-select-search
                                        [formControl]="searchProfessionCtrl"
                                        [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                        [placeholderLabel]="'search_form.search' | translate"
                                        >
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let professionData of listProfessionFilter | async" [value]="professionData?.ma" [matTooltip]="professionData.ma + ' - ' + professionData?.ten">
                                        {{ professionData.ma }} - {{ professionData?.ten }}
                                    </mat-option>
                                </mat-select>
                                <button *ngIf="configForm.controls['profession'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('profession')">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-error *ngIf="!configForm.controls['profession'].value">
                                    {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.business_industry" | translate)}) }}
                                </mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-3"> 
                            <!-- Loại hình doanh nghiệp -->
                            <mat-form-field class="w-100">
                                <mat-label>{{'labor_utilization_report.enterprise_type' | translate}}</mat-label>

                                <mat-select id="status" name="status" formControlName="businessType"
                                [placeholder]="'labor_utilization_report.select_business_field' | translate">
                                <mat-option>
                                  <ngx-mat-select-search
                                    [formControl]="searchBusinessTypeCtrl"
                                    [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                    [placeholderLabel]="'search_form.search' | translate"
                                    >
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let businessTypeData of listBusinessTypeFilter | async" [value]="businessTypeData?.ma" [matTooltip]="businessTypeData?.ten">
                                    {{ businessTypeData?.ten }}
                                </mat-option>
                              </mat-select>
                              <button *ngIf="configForm.controls['businessType'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('businessType')">
                                <mat-icon>close</mat-icon>
                              </button>
                              <!-- <mat-error *ngIf="!configForm.controls['businessType'].value">
                                {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.enterprise_type" | translate)}) }}
                              </mat-error> -->
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <!-- website -->
                            <mat-form-field class="w-100">
                                <mat-label>{{'labor_utilization_report.website' | translate}}</mat-label>
                                <input #focusInput
                                    [placeholder]="'labor_utilization_report.enter_website' | translate"
                                    formControlName="website"
                                    matInput type="text" maxlength="255" autocomplete="off"
                                    (focusout)="configForm.controls['website'].patchValue(configForm.controls['website'].value?.trim())"
                                />
                                <button *ngIf="configForm.controls['website'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('website')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                        <div class="col-3">
                            <!-- Uỷ quyền căn cứ theo -->
                            <mat-form-field class="w-100">
                                <mat-label>{{ "labor_utilization_report.authorization_ground" | translate }}</mat-label>
                                <input #focusInput
                                    [placeholder]="'labor_utilization_report.enter_authorizationGround' | translate"
                                    formControlName="authorizationGround"
                                    matInput type="text" maxlength="255" autocomplete="off"
                                    (focusout)="configForm.controls['authorizationGround'].patchValue(configForm.controls['authorizationGround'].value?.trim())"
                                />
                                <button *ngIf="configForm.controls['authorizationGround'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('authorizationGround')">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>                      
                    </div>
                </mat-expansion-panel>

                <mat-expansion-panel expanded="true" class="mt-3">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center">
                        {{ "labor_utilization_report.report_status_use_contract" | translate }}
                    </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-6">
                            <!-- Hình thức đào tạo -->
                    <div class="col-12">
                        <mat-label style="color: #2D3036">
                            {{'labor_utilization_report.form_report' | translate}}
                            <span style="color: red">*</span>
                        </mat-label>
                        <mat-error *ngIf="configForm.controls['reportAuto'].value === null">
                                    {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.form_report" | translate)}) }}
                        </mat-error>
                        <mat-radio-group class="d-flex flex-column align-items-start" #reportAuto id="reportAuto" name="reportAuto" formControlName="reportAuto">
                            <mat-radio-button [value]="false" class="pt-2 mr-3">
                                {{'labor_utilization_report.manual' | translate}}
                            </mat-radio-button>
                            <mat-radio-button [value]="true">
                                {{'labor_utilization_report.automatic' | translate}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>

                        </div>
                        <!-- Kỳ báo cáo -->
                <!-- <div class="col-4">

                    <div class="col-12">
                        <mat-label style="color: #2D3036">
                            {{'labor_utilization_report.season_report' | translate}}
                            <span style="color: red">*</span>
                        </mat-label>
                        <br>
                        <mat-radio-group class="d-flex flex-column" #seasonReport id="reportPeriod" name="reportPeriod" formControlName="reportPeriod">

                            <mat-radio-button [value]="HALF" [disabled]="!configForm.controls['reportAuto'].value" class="pt-2 mr-3">
                                {{'labor_utilization_report.semi_annual_report' | translate}}
                            </mat-radio-button>
                            <mat-radio-button [value]="YEAR" [disabled]="!configForm.controls['reportAuto'].value">
                                {{'labor_utilization_report.annual_report' | translate}}
                            </mat-radio-button>
                            <mat-radio-button [value]="CUSTOM" [disabled]="configForm.controls['reportAuto'].value || configForm.controls['reportAuto'].value === null">
                                {{'labor_utilization_report.custom' | translate}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div> -->
                <div class="col-3" style="padding: 0px !important;">
                            <!-- Chọn ngày -->
                            <mat-form-field class="w-100 col-12">
                                <mat-label>{{'labor_utilization_report.select_day_report' | translate}}</mat-label>

                                <mat-select id="reportDate" name="reportDate" formControlName="reportDate" [placeholder]="'labor_utilization_report.pick_date' | translate"
                                    [disabled]="!configForm.get('reportAuto').value" [required]="configForm.get('reportAuto').value">
                                <mat-option>
                                  <ngx-mat-select-search
                                    [formControl]="pickDateReportCtrl"
                                    [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                    [placeholderLabel]="'labor_utilization_report.input_date' | translate"
                                    >
                                  </ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let day of DataDays | async" [value]="day">
                                 {{ day }}
                                </mat-option>
                              </mat-select>
                              <button *ngIf="configForm.controls['reportDate'].value" mat-button type="button" matSuffix mat-icon-button aria-label="Clear" (click)="clearData('reportDate')">
                                <mat-icon>close</mat-icon>
                              </button>
                              <mat-error *ngIf="!configForm.controls['reportDate'].value && configForm.controls['reportAuto'].value">
                                    {{ "validation.field_required" | translate : ({field: ("labor_utilization_report.select_day_report" | translate)}) }}
                                </mat-error>
                                <mat-hint style="font-style: italic; font-size: 14px; color: #2D3036;" *ngIf="configForm.controls['reportDate'].value && configForm.controls['reportAuto'].value">
                                    {{ 'validation.select_date_for_report' | translate: {date_report: configForm.controls['reportDate'].value?.toString().padStart(2, '0') } }}
                                </mat-hint>
                            </mat-form-field>
                </div>

            </div>
                </mat-expansion-panel>

                <!-- Huỷ bỏ & Lưu  -->
                <mat-card-actions class="text-center">
                    <button mat-stroked-button color="primary" class="mr-3" (click)="cancelSaveForm()" type="button" [disabled]="!isValueFormChange">
                        <mat-icon class="mr-0">cancel</mat-icon>
                        {{'button.cancel' | translate}}
                    </button>
                    <button mat-raised-button type="submit" color="primary" [disabled]="!isValueFormChange || configForm.invalid">
                        <mat-icon class="mr-0">save</mat-icon>
                        {{'button.update' | translate}}
                    </button>
                </mat-card-actions>
            </mat-accordion>
        </form>
    </mat-card-content>
</mat-card>
